import db from '@mobile/db/db';

const storeName = 'assignees';

export default {
    async add(assignees) {
        await db.open();
        return db.add(storeName, assignees)
    },

    async first() {
        await db.open();
        return db.getAll(storeName)[0];
    },

    async clear() {
        await db.open();
        return db.clearStore(storeName)
    }
};
